import common from "../../common";
import QuestionInputSelectMulti from "./QuestionInputSelectMulti";

export default class QuestionInputSelectMultiGraph extends QuestionInputSelectMulti {
    constructor(question, view) {
        super(question, view);
    }

    selectOption(option) {
        this._selected.push(option.value);
        this._view.setAnswer(this._selected);
        option.toggle = true;
    }
}